import SaleInfo, { Sale } from "./SaleInfo";
import ScrollTo from "../common/ScrollTo";
import ZeroSales from "./ZeroSales";

interface ISalesResultsProps {
  items: Sale[];
}

let queryParamSalesCode: string = "";
let deepLinkScrollFinished: boolean = false;

const SalesResults: React.FC<ISalesResultsProps> = ({ items }) => {
  if (!deepLinkScrollFinished) {
    const urlParams = new URLSearchParams(window.location.search);
    queryParamSalesCode = urlParams?.get("code");
  }

  const handleScrollEnd = () => {
    deepLinkScrollFinished = true;
  };

  const getIsQuerySaleMatch = (sale: Sale) => {
    if (queryParamSalesCode) {
      return sale.publishedSaleCode === queryParamSalesCode;
    }

    return false;
  };

  const getIsDeepLinking = (sale: Sale) => {
    return !deepLinkScrollFinished && getIsQuerySaleMatch(sale);
  };

  if (items.length === 0) {
    return <ZeroSales />;
  }

  return (
    <>
      {items.map((sale: Sale, index: number) => {
        return (
          <ScrollTo
            key={index}
            active={getIsDeepLinking(sale)}
            behavior="smooth"
            onScrollEnd={handleScrollEnd}
          >
            <SaleInfo
              sale={sale}
              index={index}
              expand={getIsQuerySaleMatch(sale)}
            />
          </ScrollTo>
        );
      })}
    </>
  );
};

export default SalesResults;
